export default (value: any, defaultValue: any) =>
  value === undefined ? defaultValue : value;
